import {combineReducers} from 'redux';
import getCollapsedState from './functionReducers';
import getLanguage from './languageReducer';

const rootReducer = combineReducers({
     collapsable: getCollapsedState,
     language: getLanguage
});

export default rootReducer;